import {
  Easing,
  EffectConfig,
  EffectParams,
  EffectPower,
  UnitLengthPercentage,
  SchemaGroup,
} from '../types';
import {
  allowReplay,
  delay,
  duration,
  power,
  angle as direction,
  easing,
} from './baseParams';

export interface GlitchIn extends EffectParams {
  direction: number;
  distance: UnitLengthPercentage;
  power?: EffectPower;
  startFromOffScreen?: Boolean;
  easing?: Easing;
}

const name = 'GlitchIn';
const groups: SchemaGroup[] = ['entrance', 'animation'];

export const config: EffectConfig<GlitchIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1200 },
    power: { ...power, default: 'soft' },
    direction: { ...direction },
    distance: {
      type: 'number-with-unit',
      min: 0,
      max: 400,
      step: 1,
      default: { value: 400, type: 'px' },
      mobileDefault: { value: 50, type: 'px' },
      units: ['px'],
    },
    startFromOffScreen: {
      type: 'boolean',
      default: true,
    },
  },
} as const;

export const responsiveConfig: EffectConfig<GlitchIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1200 },
    direction: { ...direction },
    startFromOffScreen: {
      type: 'boolean',
      default: true,
    },
    distance: {
      type: 'number-with-unit',
      min: 0,
      max: 400,
      step: 1,
      default: { value: 20, type: 'percentage' },
      units: ['percentage', 'px', 'vh', 'vw'],
    },
    easing: { ...easing, default: 'cubicInOut' },
  },
} as const;
